import React from "react";
import "./App.css";
import { Routes, Route } from "react-router-dom";
import Header from "./components/Header";
import Hero from "./components/Hero";
import HeroVideo from "./components/HeroVideo";
import FeaturedProductsSlider from "./components/FeaturedProductsSlider";
import About from "./components/About";
import Products from "./components/Products";
import Process from "./components/Process";
import Contact from "./components/Contact";
import Footer from "./components/Footer";
import WhatsAppButton from "./components/WhatsAppButton";
import PrivacyPolicy from "./components/PrivacyPolicy";
import Certificates from "./components/Certificates";
import Blog from "./components/Blog";
import BlogPost from "./components/BlogPost";
import HeroDemo from "./components/HeroDemo";
import AdminDashboard from "./components/AdminDashboard";

const HomePage = () => {
  return (
    <>
      <Header />
      <main>
        <Hero />
        <FeaturedProductsSlider />
        <About />
        <Products />
        <Process />
        <Contact />
      </main>
      <Footer />
      <WhatsAppButton />
    </>
  );
};

function App() {
  return (
    <div className="App">
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/demo" element={<HeroDemo />} />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="/certificates" element={<Certificates />} />
        <Route path="/blog" element={<Blog />} />
        <Route path="/blog/:id" element={<BlogPost />} />
        <Route path="/admin" element={<AdminDashboard />} />
      </Routes>
    </div>
  );
}

export default App;
